import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { replace } from 'connected-react-router'

import MainView from '../components/MainView/MainView'

import { setPrimaryInfo } from '../../../modules/profile/actions/creators'

import {
  setRecoveryRequestId,
  setRecoveryStep,
  setRecoveryMaskedData as setMaskedData,
} from '../../../modules/recovery/actions/creators'
import {
  setProfileModalPage,
  displayProfileModal,
} from '../../../modules/profile/actions/creators'

import { setAccessToken } from '../../../modules/auth/actions/creators'

import { doSubscribeToFirebaseMessaging } from '../../../controllers/Firebase'
import {
  doVerifyOtp,
  doResendOtpRecoveryRequest,
} from '../../../controllers/AccountRecovery'

const mapStateToProps = reduxState => {
  const { recovery, auth } = reduxState
  const { firebaseMessagingToken } = auth
  const { recoveryStep, recoveryRequestId, recoveryMaskedData } = recovery

  return {
    recoveryRequestId,
    recoveryStep,
    recoveryMaskedData,
    firebaseMessagingToken,
    doSubscribeToFirebaseMessaging,
    doVerifyOtp,
    doResendOtpRecoveryRequest,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setPrimaryInfo,
      setMaskedData,
      setRecoveryRequestId,
      setRecoveryStep,
      setProfileModalPage,
      displayProfileModal,
      setAccessToken,
      replace,
    },
    dispatch,
  )

const ConnectedMainView = connect(mapStateToProps, mapDispatchToProps)(MainView)

export default ConnectedMainView
